// node modules
import { observable, action, autorun } from 'mobx';
import dayjs from 'dayjs';

export default class LocaleStore {
  @observable lang: Lang = 'en';

  @action setLang = (lang: Lang) => {
    this.lang = lang;
  };

  setDayjsLocale = autorun(() => {
    dayjs.locale(this.lang);
  });
}
